<template>
  <button class="app-multiselect__select-all-button" @click="selectAll()">
    {{ footerText }}
  </button>
</template>

<script>
export default {
  props: {
    multiselectRef: {
      type: Object,
      default: () => {},
    },
    footerText: {
      type: String,
      default: "Selecionar Todos",
    },
  },
  methods: {
    selectAll() {
      this.multiselectRef._data.selectedItemsLocal =
        this.multiselectRef._data.datalistFiltered.map((item) => item.value) ||
        [];
    },
  },
};
</script>

<style lang="scss">
.app-multiselect__container {
  .app-multiselect__select-all-button {
    background-color: #fff;
    border: 0;
    width: 100%;
    padding: 4px;
    color: #974900;
    text-align: center;
    font-family: Raleway;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.15px;
    border-radius: 5px;
    user-select: none;

    &:hover {
      background: #ffede2;
    }

    &:active {
      background: #ffdbc4;
    }
  }
}
</style>
